<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" lg="12">
                    <b-form-group :label="$t('asal_type')">
                        <ValidationProvider name="request_type" rules="required" v-slot="{valid, errors}">
                            <multi-selectbox v-model="formData.request_type" :multiple="false" :options="asal_type" :validate-error="errors[0]"></multi-selectbox>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>

                <b-col cols="12" lg="12" v-if="formData.request_type=='E'">
                    <b-form-group :label="$t('asal_delay_reasons')">
                        <ValidationProvider name="request_reason" rules="required" v-slot="{valid, errors}">
                            <parameter-selectbox  v-model="formData.request_reason" code="asal_delay_reasons" class="mb-1" :prepend="$t('variable_language')">
                            </parameter-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>

                <b-col cols="12" lg="12" v-if="formData.request_type=='I'">
                    <b-form-group :label="$t('asal_delay_reasons')">
                        <ValidationProvider name="request_reason" rules="required" v-slot="{valid, errors}">
                            <parameter-selectbox
                                v-model="formData.request_reason" code="asal_delay_cancellation_reasons" class="mb-1" :prepend="$t('variable_language')"
                            :validate-error="errors[0]">
                            </parameter-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>

                <b-col cols="12" lg="12" v-if="formData.request_type=='E'">
                    <b-form-group :label="$t('asal_maximum_time_reasons')">
                        <ValidationProvider name="reason_to_increase_max_duration" rules="" v-slot="{valid, errors}">
                            <parameter-selectbox
                                v-model="formData.reason_to_increase_max_duration"
                                code="asal_maximum_time_reasons" class="mb-1"
                                sort="id"
                                :prepend="$t('variable_language')"
                            :validate-error="errors[0]">
                            </parameter-selectbox>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="12" v-if="formData.reason_to_increase_max_duration">
                    <b-form-group :label="$t('extra_time')">
                        <ValidationProvider name="extra_time" rules="required" v-slot="{valid, errors}">
                            <b-form-input type="number" step="1"
                                v-model="formData.extra_time"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="12">
                    <b-form-group :label="$t('signature_name')">
                        <ValidationProvider name="signer_code" rules="required" v-slot="{valid, errors}">
                            <parameter-selectbox
                                v-model="formData.signer_code"
                                code="military_document_signatories"
                                class="mb-1" :prepend="$t('variable_language')"
                                :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-row>


            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="createForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import ParameterIdSelectbox from "@/components/interactive-fields/ParameterIdSelectbox";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
// Services
import AsalService from "@/services/AsalService";
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"


export default {
    props:{
        student_program_id:null,

    },
    components: {
        ParameterSelectbox,
        ValidationProvider,
        ValidationObserver,
        ParameterIdSelectbox
    },
    data() {
        return {
            signer_national_id:null,
            asal_type:[
                { text: 'Erteleme', value: 'E' },
                { text: 'İptal', value: 'I' }

            ],
            formData: {},
            formLoading: false,
        }
    },
    methods: {
        nameWithLang ({ name}) {
            return `${name}`
        },
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            this.formData.student_program_id= this.student_program_id
            if (isValid) {
                this.formLoading = true;
              AsalService.store(this.formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.$emit('createFormSuccess', true);
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false
                    })
            }
        }
    }
}
</script>

